var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClicks2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#E2EEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 19.8261,
    height: 19.8261,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_121_425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_121_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.3126L17.4813 18.2501H20.6688L16 14.5751V20.3126ZM21.3625 26.0313C21.075 26.1688 20.7875 26.1846 20.5 26.0786C20.2125 25.9721 20 25.7751 19.8625 25.4876L17.6125 20.6501L15.8687 23.0876C15.6562 23.3876 15.375 23.4813 15.025 23.3688C14.675 23.2563 14.5 23.0188 14.5 22.6563V13.0376C14.5 12.7251 14.6405 12.5001 14.9215 12.3626C15.203 12.2251 15.4687 12.2563 15.7188 12.4563L23.2938 18.4188C23.5813 18.6313 23.6655 18.9063 23.5465 19.2438C23.428 19.5813 23.1875 19.7501 22.825 19.7501H19.675L21.9062 24.5313C22.0438 24.8188 22.0595 25.1063 21.9535 25.3938C21.847 25.6813 21.65 25.8938 21.3625 26.0313Z",
    fill: "#0052C9"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClicks2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clicks2.9796f68a.svg";
export { ForwardRef as ReactComponent };